import { fotActions } from "@store/fot";
import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useStateRef from "react-usestateref";

export function useAiSaasState() {
  const dispatch = useDispatch();
  const aiSaasRef = useRef();
  const saasLoadingState = useState(false);
  const saasV2LoadingState = useState(false);
  const showSaasOutputListState = useState(true);

  const saasV2InputChildEdgeState = useStateRef([]);
  const saasV2InputChildNodeState = useStateRef([]);

  const inputId: any[] = useSelector((state: any) => state.fot.inputId);
  const setInputId = useCallback(
    (val: any) => {
      dispatch(fotActions.setInputId(val));
    },
    [dispatch]
  );
  // 删除 input 预览状态
  const onCloseInputId = useCallback(
    (id: any) => {
      const newInputId = inputId.filter(x => x !== id);
      setInputId(newInputId);
    },
    [inputId, setInputId]
  );

  const saasInputChildNodeState = useStateRef<any[]>([]);
  const saasInputChildEdgeState = useStateRef<any[]>([]);

  return {
    inputId,
    setInputId,
    /**
     * @deprecated `onCloseInputId`
     */
    closeInputId: onCloseInputId,
    onCloseInputId,

    aiSaasRef,
    saasLoadingState,
    saasV2LoadingState,
    showSaasOutputListState,
    saasInputChildNodeState,
    saasInputChildEdgeState,
    saasV2InputChildEdgeState,
    saasV2InputChildNodeState,
  };
}
